import { Backdrop, Box, Button, CircularProgress } from "@mui/material";
import React from "react";
import { setIsOpenWidget } from "../../store/slice/Addguest.slice";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Widget from "./Widget";
import useHorecaWidget from "../../hooks/useHorecaWidget";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

let loadSettings = null;
let widgetIdSettings = null;

const HotelWidgetMain = ({ floating }) => {
  const {
    isOpenWidget,
    send,
    handleClose,
    widgetConfig,
    theme,
    widgetLoading,
    openWidget,
    setOpenWidget,
    dispatch,
    buttonText,
    getWidgetPositionStyle,
    combinationLoading,
    reservTypeLoading,
  } = useHorecaWidget();

  // if (widgetLoading) {
  //   return (
  //     <Backdrop
  //       sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
  //       open={widgetLoading}
  //       onClick={handleClose}
  //     >
  //       <CircularProgress color="inherit" />
  //     </Backdrop>
  //   );
  // }


 
    return (
      send("100vh", "100vw", "0px", "0px", "0px", "", floating),
      (
        <Box
        sx={{
          width: "100%",
          height: "100vh",
         display: "flex",
         justifyContent: "center",
               alignItems: "flex-start",
          backgroundColor: "",
          position: "relative",
          mt:2
      
          
        }}
        >
        <Widget
          data={{
            isOpenWidget,
            send,
            handleClose,
            widgetConfig,
            theme,
            widgetLoading,
            openWidget,
            setOpenWidget,
            dispatch,
            buttonText,
            getWidgetPositionStyle,
            combinationLoading,
            reservTypeLoading,
          }}
          handleClose={() => setOpenWidget(!openWidget)}
        />
        </Box>
      )
    );
  

};
export default HotelWidgetMain;
